var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    {
      staticClass: "fill-height"
    },
    [
      _vm.hosting_error
        ? _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c(
                "v-card",
                {
                  staticClass: "app-card",
                  attrs: {
                    text: ""
                  }
                },
                [
                  _c("v-card-text", [
                    _c(
                      "p",
                      {
                        staticClass: "mb-0"
                      },
                      [_vm._v(_vm._s(_vm.hosting_error))]
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        : [
            _c(
              "v-col",
              {
                attrs: {
                  cols: "12",
                  sm: "6"
                }
              },
              [
                _c("v-server-status-info", {
                  attrs: {
                    loading: _vm.loading
                  }
                })
              ],
              1
            ),
            _c(
              "v-col",
              {
                attrs: {
                  cols: "12",
                  sm: "6"
                }
              },
              [_c("v-server-product-info")],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }